// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uBhXyUzH8WdNyR {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: 12px;
  background-color: var(--ds-surface, #ffffff);
}
.Wp1xUtg6MsY1Ym {
  display: block;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.m1IhzSekTDNIws {
  padding: 32px 140px 40px 140px;
  text-align: center;
}
.zBDK1Gqjz5dhia {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  column-gap: 8px;
}
.yAWdXC4iBbXrrk {
  position: absolute;
  top: 8px;
  right: 16px;
  color: #ffffff;
}
.yAWdXC4iBbXrrk:hover,
.yAWdXC4iBbXrrk:active {
  color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gaWelcomeModal": `uBhXyUzH8WdNyR`,
	"headingImage": `Wp1xUtg6MsY1Ym`,
	"contentContainer": `m1IhzSekTDNIws`,
	"ctasContainer": `zBDK1Gqjz5dhia`,
	"closeButton": `yAWdXC4iBbXrrk`
};
export default ___CSS_LOADER_EXPORT___;
